import React, { useState,useEffect } from "react";
import styled from "styled-components";
import cer1 from "../images/cer1.png";
import cer2 from "../images/cer2.png";
import cer3 from "../images/cer3.png";
import cer4 from "../images/cer4.png";
import cer5 from "../images/cer5.png";
import cer6 from "../images/cer6.png";
import cer7 from "../images/cer7.png";
import cer8 from "../images/cer8.png";
import cer9 from "../images/cer9.png";
import cer10 from "../images/cer10.png";
import cer11 from "../images/cer11.png";
import cer12 from "../images/cer12.png";
import cer13 from "../images/cer13.png";
import cer14 from "../images/cer14.png";
import cer18 from "../images/cer18.png";

import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "react-modal";
Modal.setAppElement("#root");
function Certificates() {
  const [openadd, setadd] = useState(false);
  const [imagepop, setimagepop] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const popthewin = (certificate) => {
    setimagepop(certificate);
    setadd(true);
  };
  
  return (
    <Container>
      <Link to={"/"}>
        <Button>Back To Home</Button>
      </Link>
      <div className="certificates">
      <div className="cert">
          <img onClick={() => popthewin(cer18)} src={cer18} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer1)} src={cer1} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer2)} src={cer2} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer11)} src={cer11} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer9)} src={cer9} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer10)} src={cer10} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer3)} src={cer3} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer8)} src={cer8} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer4)} src={cer4} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer5)} src={cer5} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer6)} src={cer6} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer7)} src={cer7} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer12)} src={cer12} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer13)} src={cer13} />
        </div>
        <div className="cert">
          <img onClick={() => popthewin(cer14)} src={cer14} />
        </div>
      </div>

      <Modal
        isOpen={openadd}
        onRequestClose={() => {
          setadd(false);
        }}
      >
        <CloseIcon
          style={{
            position: "absolute",
            right: "20",
            top: "21",
            cursor: "pointer",
          }}
          onClick={() => {
            setadd(false);
          }}
        ></CloseIcon>
        <img style={{ width: "80%", height: "95%" }} src={imagepop} />
      </Modal>
    </Container>
  );
}

export default Certificates;

const Container = styled.div`
  background: linear-gradient(to right, #cc2b5e, #753a88);
  /* height: 100vh; */
  Button {
    text-decoration: none;
    background: red;
    /* background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4); */
    /* background-size: 400%; */
    color: white;
    margin-top: 30px;
    transform: translate(-50%, -50%);
    animation: animateDown infinite 1.5s;
    &:hover {
      background: black;
    }
  }
  .certificates {
    display: flex;
    flex-wrap: wrap;
    margin-top: 100px;
    align-items: center;
    padding-bottom: 95px;
  }
  .cert {
    cursor: pointer;
    /* flex-basis: 32%; */
    border-radius: 10px;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;
    margin-left: 100px;
    margin-right: 100px;
  }
  .cert img {
    width: 300px;
    height: 200px;
    border-radius: 15px;
    display: block;
  }
`;
